<template>
  <div v-if="loading">
    <Spin
      :pointNum="8"
      :translateX="25"
      background="var(--base-primary-bgColor)" />
  </div>
  <div
    v-else
    class="table-list-box">
    <div
      v-if="!emptyFlag"
      class="table-list-content-box">
      <div class="common-table-box">
        <el-table
          highlight-selection-row
          class="publish-table"
          ref="elementTable"
          :data="dataList"
          height="100%"
          :header-row-class-name="customHeader"
          @select="selectChange"
          @select-all="selectChange"
          @cell-click="handleClick">
          <el-table-column
            type="selection"
            width="60"></el-table-column>
          <el-table-column
            label="序号"
            type="index"
            width="55"></el-table-column>
          <el-table-column label="名称">
            <template v-slot="{ row }">
              <div
                :class="`icon-column ${isDisable(row) ? 'disabled' : ''}`"
                @click="viewElem(row)">
                <div class="icon-box">
                  <icon-svg
                    class="icon"
                    icon-class="ic-ico-group" />
                </div>
                <div
                  class="text-overflow"
                  :title="formatName(row.name)">
                  {{ formatName(row.name) }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="格式">
            <template v-slot="{ row }">
              {{ formatFileType(row) }}
            </template>
          </el-table-column>
          <el-table-column label="大小">
            <template v-slot="{ row }">
              {{
                `${formatFileSize(row.length).fileSize}${
                  formatFileSize(row.length).unit
                }`
              }}
            </template>
          </el-table-column>
          <el-table-column label="转换状态">
            <template v-slot="{ row }">
              <div
                v-if="row.status === 0"
                class="status-text">
                <div class="circle bg-color1"></div>
                <span class="color1">未转换</span>
              </div>
              <div
                v-else-if="row.status === 1"
                class="status-text">
                <div class="circle bg-color2"></div>
                <span class="color2">排队中</span>
              </div>
              <div
                v-else-if="row.status === 4"
                class="status-text">
                <div class="circle bg-color3"></div>
                <span class="color3">转换失败</span>
              </div>
              <div
                v-else-if="row.status === 5"
                class="status-text">
                <div class="circle bg-color4"></div>
                <span class="color4">已转换</span>
              </div>
              <div
                v-else-if="row.status === 2"
                class="common-progress-box">
                <el-progress
                  :show-text="false"
                  :percentage="row.rate">
                </el-progress>
                <div class="custom-text">
                  <div class="text">{{ `${row.rate ? row.rate : 0}%` }}</div>
                  <div class="progress-name-box text-overflow">
                    {{ row.rateMsg ? row.rateMsg : '' }}
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="创建日期"
            width="180">
            <template v-slot="{ row }">
              {{
                row.uploadTime
                  ? formatTime(row.uploadTime)
                  : formatTime(row.creationTime)
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="180">
            <template v-slot="{ row }">
              <div class="common-button-box operation-cell">
                <el-button
                  type="text"
                  size="small"
                  :disabled="isConverting(row)"
                  @click="downloadElement(row)">
                  下载
                </el-button>
                <el-button
                  v-if="isChecked('Project.ComponentLibrary.Private.Delete')"
                  type="text"
                  size="small"
                  :disabled="isConverting(row)"
                  @click="deleteElement(row)">
                  删除
                </el-button>
                <el-button
                  v-if="isChecked('Project.ComponentLibrary.Private.Move')"
                  type="text"
                  size="small"
                  :disabled="isConverting(row)"
                  @click="openMoveDialog([row])">
                  移动到
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="common-pagination-box">
        <el-pagination
          class="pagination-primary"
          popper-class="common-pagination-popper-box"
          layout="sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100, 150, 200]"
          :page-size="pageSize"
          :current-page="currentPage"
          :total="total"
          @size-change="sizeChange"
          @current-change="pageChange">
        </el-pagination>
      </div>
    </div>
    <Empty
      v-else
      :uploadFile="uploadFile" />
  </div>
</template>

<script>
import Spin from '@/components/Spin.vue'
import Empty from '../components/Empty.vue'
import { Store } from '@/utils/store'
import { formatTime, formatFileSize, getTokenId } from '@/utils/generalMethods'

import {
  privateElemListService,
  privateElemDeleteService,
  privateElemBatchDeleteService,
  getElemsConvertingProgress,
  getElemConvertStatus
} from '@/service/interface'

export default {
  data() {
    return {
      loading: true,
      emptyFlag: false,
      dataList: [],
      selectedElements: [],
      convertingElems: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      customHeader: ''
    }
  },
  props: {
    initCatalog: Function,
    currNode: Object,
    elemUploader: Object,
    filterUser: String,
    sortValue: String,
    keywords: String,
    openMoveDialog: Function
  },
  components: {
    Spin,
    Empty
  },
  created() {
    if (Object.keys(this.currNode).length) {
      this.initDataList()
    }
  },
  mounted() {
    setTimeout(() => {
      const currentBody = this.$refs.elementTable?.bodyWrapper
      currentBody &&
        currentBody.addEventListener('scroll', ev => {
          const scrollTop = ev.target.scrollTop
          this.customHeader = scrollTop > 10 ? 'darkHeader' : ''
        })
    }, 500)
  },
  methods: {
    initDataList() {
      this.loading = true
      this.queryElementList().then(response => {
        let { dataList, total } = response
        this.dataList = dataList
        this.total = total

        this.emptyFlag = total ? false : true

        this.loading = false

        this.$nextTick(() => {
          // 空态页上传按钮
          let emptyUploadDom = document.getElementById('empty-element-upload')
          if (emptyUploadDom) {
            let child = emptyUploadDom.children[0]
            if (!child.className.includes('webuploader-pick')) {
              this.elemUploader.uploader.addButton({
                id: '#empty-element-upload'
              })
            }
          }
        })

        this.queryConvertProgress(dataList)
      })
    },
    viewElem(elemInfo) {
      if (!this.isChecked('Project.ComponentLibrary.Private.ModelView')) return

      if (elemInfo.status !== 5) {
        this.$message.warning('文件尚未转换，请转换成功后再查看')
        return
      }

      let dataSetId = elemInfo.dataSetId
      const routerUrl = this.$router.resolve({
        path: `./elementView`,
        query: { elemType: 'PrivateElem', dataSetId, elemName: elemInfo.name }
      })

      window.open(routerUrl.href, '_blank')
    },
    selectChange(selection) {
      this.selectedElements = selection
    },
    handleClick(dataInfo, column) {
      // if (column.label === '操作' || column.type === 'selection') return
      // if (!column.label.includes('名称')) {
      //   this.$refs.elementTable.toggleRowSelection(dataInfo)
      //   return
      // }
    },
    isDisable(elemInfo) {
      return !(elemInfo.status === 5)
    },
    isConverting(elemInfo) {
      const convertingValue = [0, 1, 2] // 新创建、排队中、转换中的状态值
      return convertingValue.includes(elemInfo.status)
    },
    uploadFile() {
      this.elemUploader.setStatus('waiting')
    },
    downloadElement(elemInfo) {
      let files = [elemInfo]
      this.downloadFiles(files)
    },
    batchDownloadElem() {
      let elements = this.selectedElements
      if (!elements.length) {
        this.$message.warning('请勾选需要下载的构件')
        return
      }

      let invalidElems = elements.filter(
        el => el.status === 1 || el.status === 2
      )
      if (invalidElems.length) {
        this.$message.warning('有文件正在转换中，请稍后再试')
        return
      }

      this.downloadFiles(elements)
    },
    downloadFiles(files) {
      this.$message({
        message: '开始下载文件，请勿重复操作......',
        type: 'info',
        duration: 3 * 1000
      })

      files.forEach((item, index) => {
        let url = ''
        let tokenId = getTokenId()
        if (window.downloadUrl.includes('http')) {
          url = `${window.downloadUrl}/${item.fileDataId}?token=${tokenId}`
        } else {
          url = `${window.serverUrl}/${window.downloadUrl}/${item.fileDataId}?token=${tokenId}`
        }

        this.downloadURL(url, index + 1)
      })
    },
    downloadURL(url, id) {
      let hiddenIFrameID = 'hiddenDownloader' + id
      let iframe = document.createElement('iframe')
      iframe.id = hiddenIFrameID
      iframe.style.display = 'none'
      document.body.appendChild(iframe)
      iframe.src = url
    },
    deleteElement(elemInfo) {
      this.$confirm('删除后需要重新上传并转换，是否继续', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let fileId = elemInfo.id
          privateElemDeleteService(fileId).then(response => {
            if (response.isSuccess) {
              this.initCatalog().then(() => {
                this.initDataList()
                this.$message.success('删除成功')
              })
            } else {
              this.$message.error(response.errMsg)
            }
          })
        })
        .catch(() => {
          // this.$message.info('取消删除')
        })
    },
    batchDeleteElement() {
      let elements = this.selectedElements
      if (!elements.length) {
        this.$message.warning('请先选择构件')
        return
      }

      let invalidElems = elements.filter(
        el => el.status === 1 || el.status === 2
      )
      if (invalidElems.length) {
        this.$message.warning('有文件正在转换中，请稍后再试')
        return
      }

      this.$confirm('删除后需要重新上传并转换，是否继续', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let fileIds = elements.map(el => el.id)
          privateElemBatchDeleteService({ fileIds }).then(response => {
            if (response.isSuccess) {
              this.initCatalog().then(() => {
                this.initDataList()
                this.$message.success('删除成功')
              })
            } else {
              this.$message.error(response.errMsg)
            }
          })
        })
        .catch(() => {
          // this.$message.info('取消删除')
        })
    },
    batchMoveNode() {
      let elements = this.selectedElements
      if (!elements.length) {
        this.$message.warning('请先勾选文件')
        return
      }
      let invalidElems = elements.filter(
        el => el.status === 1 || el.status === 2
      )
      if (invalidElems.length) {
        this.$message.warning('有文件正在转换中，请稍后再试')
        return
      }

      this.openMoveDialog(elements)
    },
    sizeChange(pageSize) {
      this.pageSize = pageSize
      this.currentPage = 1
      this.queryElementList().then(response => {
        let { dataList, total } = response
        this.dataList = dataList
        this.total = total
      })
    },
    pageChange(currentPage) {
      this.currentPage = currentPage
      this.queryElementList().then(response => {
        let { dataList, total } = response
        this.dataList = dataList
        this.total = total
      })
    },
    queryElementList() {
      return new Promise(resolve => {
        let userInfo = Store.userInfo
        let userId = this.filterUser ? this.filterUser : userInfo.userId
        let params = {
          userId,
          parentId: this.currNode.nodeId,
          sortType: this.sortValue,
          name: this.keywords,
          resultCount: this.pageSize,
          skipCount: (this.currentPage - 1) * this.pageSize
        }
        privateElemListService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let dataList = data.items
            let total = data.totalCount
            resolve({ dataList, total })
          }
        })
      })
    },
    queryConvertProgress(dataList) {
      const statusArray = [1, 2]
      this.progressTimer && clearInterval(this.progressTimer)

      const convertingElems = dataList.filter(el =>
        statusArray.includes(el.status)
      )
      if (convertingElems.length) {
        this.updateConvertProgress(convertingElems)
        this.progressTimer = setInterval(() => {
          this.updateConvertProgress(convertingElems)
        }, 5000)
      }
    },
    refreshElemList() {
      this.queryElementList().then(response => {
        let { dataList } = response
        this.dataList = dataList

        this.queryConvertProgress(dataList)
      })
    },
    updateConvertProgress(convertingElems) {
      let dataSetIds = convertingElems.map(el => el.dataSetId)
      getElemsConvertingProgress({ dataSetIds }).then(response => {
        if (response.isSuccess) {
          let dataList = response.data
          for (let i = 0; i < dataList.length; i++) {
            let item = dataList[i]

            let ratio = Math.round(item.ratio / 100) / 100
            let find = this.dataList.find(el => el.dataSetId === item.dataSetId)

            // 用于处理转换服务停止之后再重启的情况
            let findElem = this.convertingElems.find(
              el => el.dataSetId === item.dataSetId
            )
            if (findElem && findElem.isMarked && ratio === 0) {
              this.convertingElems = []
              this.refreshElemList()
              break
            }

            if (ratio !== 0 && find.status !== 2) {
              this.refreshElemList()
              break
            }
            if (ratio === 100) {
              getElemConvertStatus({ dataSetId: item.dataSetId }).then(res => {
                if (res.isSuccess) {
                  let result = res.data
                  let status = result.status
                  if (status === 10 || status === 20) {
                    this.refreshElemList()
                  } else {
                    this.$set(find, 'rate', 99)
                  }
                }
              })
              break
            } else {
              this.$set(find, 'rate', ratio)
              this.$set(find, 'rateMsg', item.message)
              if (ratio > 0) {
                if (!findElem) {
                  this.convertingElems.push({
                    dataSetId: item.dataSetId,
                    isMarked: true
                  })
                }
              }
            }
          }
        }
      })
    },
    formatName(name) {
      if (name.includes('obj.zip')) {
        return name.substring(0, name.lastIndexOf('.obj.zip'))
      } else {
        return name.substring(0, name.lastIndexOf('.'))
      }
    },
    formatFileType(fileInfo) {
      let name = fileInfo.name
      if (name.includes('obj.zip')) {
        return 'obj'
      } else {
        return fileInfo.fileType
      }
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    },
    formatTime,
    formatFileSize
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.table-list-box {
  height: 100%;

  .table-list-content-box {
    height: 100%;
    .common-table-box {
      position: relative;
      height: calc(100% - 64px);

      .el-table {
        position: absolute;
      }

      .icon-column {
        display: flex;
        align-items: center;
        cursor: pointer;
        &:hover {
          color: var(--primary-color);
          text-decoration: underline;
        }

        .icon {
          color: var(--icon-color);
          font-size: 16px;
          margin-right: 10px;
          object-fit: contain;
        }
      }

      .disabled {
        color: var(--normal-status-color);
        &:hover {
          .content-box {
            .name {
              color: var(--normal-status-color);
              text-decoration: unset;
              cursor: not-allowed;
            }
          }
        }
      }

      .status-text {
        display: flex;

        .circle {
          width: 5px;
          height: 5px;
          margin: auto 10px auto 0px;
          border-radius: 50%;
        }

        .bg-color1 {
          background: var(--normal-status-color);
        }

        .bg-color2 {
          background: var(--runing-status-color);
        }

        .bg-color3 {
          background: var(--error-status-color);
        }

        .bg-color4 {
          background: var(--success-status-color);
        }

        .color1 {
          color: var(--normal-status-color);
        }

        .color2 {
          color: var(--runing-status-color);
        }

        .color3 {
          color: var(--error-status-color);
        }
        .color4 {
          color: var(--success-status-color);
        }
      }

      .common-progress-box {
        display: flex;

        .el-progress {
          width: 80%;
        }

        .custom-text {
          width: 60px;
          line-height: 12px;
          font-size: 12px;
          text-align: center;

          .text {
            color: var(--success-status-color);
          }

          .progress-name-box {
            position: absolute;
            top: 5px;
            left: 0px;
            width: calc(100% - 50px);
            color: var(--success-status-color);
          }
        }
      }
    }
  }

  .common-empty-box {
    .upload-btn {
      padding: 0px 30px;
    }
  }
}
</style>
